module.exports = __webpack_public_path__ + "img/crew_adv_05.34ea5d64.png";